import React from "react";

const ExcelIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <g transform="translate(-47.367 -47.367)">
        <path
          d="M56.367,47.367a1.5,1.5,0,0,0-.3.032v0l-7.476,1.5,0,0a1.5,1.5,0,0,0-1.219,1.471v12a1.5,1.5,0,0,0,1.222,1.474l7.476,1.494a1.484,1.484,0,0,0,.3.032,1.5,1.5,0,0,0,1.5-1.5v-15A1.5,1.5,0,0,0,56.367,47.367Zm3,1.5v2.25h1.5v1.5h-1.5v1.5h1.5v1.5h-1.5v1.5h1.5v1.5h-1.5v1.5h1.5v1.5h-1.5v2.25h4.5a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-1.5-1.5Zm3,2.25h.75a.75.75,0,0,1,0,1.5h-.75Zm-12.609,1.5h1.8l.935,2.241a4.361,4.361,0,0,1,.2.639h.023a6.661,6.661,0,0,1,.2-.653l1.043-2.227H55.6l-1.96,3.715,2.019,3.785H53.906l-1.128-2.446a2.07,2.07,0,0,1-.138-.5h-.015c-.026.114-.076.287-.152.518L51.34,60.117H49.579l2.089-3.753Zm12.609,1.5h.75a.75.75,0,1,1,0,1.5h-.75Zm0,3h.75a.75.75,0,1,1,0,1.5h-.75Zm0,3h.75a.75.75,0,1,1,0,1.5h-.75Z"
          transform="translate(0 0)"
        />
      </g>
    </svg>
  );
};

export default ExcelIcon;
